import { GlobalVars } from "../../../state/global/globalVars";

import UilCancel from "@iconscout/react-unicons/icons/uil-cancel";
import UilSave from "@iconscout/react-unicons/icons/uil-save";

import Button, { RemoveButton } from "../form/Button";

export default function ModalWrapper({title, children, yesno, footerContent, className, onClose, onSubmit, submitDisabled, data, ...rest}) {
    return (
        <div className={`flex flex-col  max-h-[90vh] rounded-lg bg-cityside-primary-blue ${className}`} {...rest}>
            <div className="flex items-center justify-between mx-2">
                <h2 className="m-4 text-light-11">{title}</h2>
                <RemoveButton className="p-1" large={true} onClick={onClose}/>
            </div>
            <div className="p-1 bg-light-5"></div>
            {children}
            <div className="flex flex-col sm:flex-row gap-2 m-2 lg:m-2 lg:mx-4">
                {footerContent}
                <div className="w-full sm:w-auto grid grid-row grid-cols-2 gap-2 ml-auto">
                    {onSubmit && 
                        <Button
							disabled={submitDisabled ? true : false}
                            text={yesno ? "Yes" : "Submit"}
                            type="submit"
                            className="w-full sm:w-32 text-center"
                            icon={<UilSave size={GlobalVars.iconSize.xs} />}
                            onClick={onSubmit}
                        />
                    }
                    <Button
                        text={onSubmit ? yesno ? "No" : "Cancel" : "Close"}
                        className={`w-full sm:w-32 text-center ${!onSubmit ? "col-span-2" : ""}`}
                        icon={<UilCancel size={GlobalVars.iconSize.xs} />}
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    )
}

/*

Sample props

title="form title"
className="classes"
onClose={somefunction}
onSubmit={somefunction}
formData={somevariable}
footerContent={<div></div>} //content in left footer

*/